<template>
    <div class="approve-refund-dialog">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-form-item label="Số tiền cần hoàn lại">
                <el-input :value="refundAmountText" disabled/>
            </el-form-item>

            <el-form-item label="Trạng thái duyệt" prop="processingStatus">
                <el-select
                    v-model="form.processingStatus"
                    class="w-100"
                    placeholder="Chọn phân loại"
                    popper-class="approve-refund-dialog__select-popper"
                >
                    <el-option
                        v-for="item in statusOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                </el-select>
            </el-form-item>

            <el-form-item label="Ghi chú">
                <el-input
                    v-model="form.note"
                    :rows="4"
                    maxlength="500"
                    placeholder="Nhập ghi chú"
                    show-word-limit
                    type="textarea"
                />
            </el-form-item>
        </el-form>

        <div class="approve-refund-dialog__footer">
            <button :disabled="submitting" class="btn btn-secondary-muted" type="button" @click="closeDialog">
                Hủy bỏ
            </button>
            <el-button
                :disabled="submitting"
                :loading="submitting"
                class="btn btn-primary text-white approve-refund-dialog__btn-submit"
                type="button"
                @click="submit"
            >
                Xác nhận
            </el-button>
        </div>
    </div>
</template>

<script>
import {PROCESSING_STATUS} from "../model/DepositRefundModel";

const STATUS_OPTIONS = [
    {label: "Duyệt hoàn phí bổ trợ", value: PROCESSING_STATUS.WAITING_REFUND},
    {label: "Từ chối hoàn phí bổ trợ", value: PROCESSING_STATUS.REJECTED},
];

export default {
    name: "DialogApproveDepositRefund",
    props: {
        refundAmount: {
            type: [Number, String],
            default: null,
        },
        submitting: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            statusOptions: STATUS_OPTIONS,
            form: {
                processingStatus: "",
                note: "",
            },
            rules: {
                processingStatus: [{required: true, message: "Vui lòng chọn trạng thái duyệt", trigger: "change"}],
            },
        };
    },
    computed: {
        refundAmountText() {
            if (this.refundAmount === null || this.refundAmount === undefined || this.refundAmount === "") {
                return "—";
            }
            const amount = Number(this.refundAmount);
            return Number.isNaN(amount) ? this.refundAmount : `${amount.toLocaleString("vi-VN")} đ`;
        },
    },
    mounted() {
        this.resetForm();
    },
    methods: {
        resetForm() {
            this.form = {
                processingStatus: "",
                note: "",
            };
            this.$nextTick(() => {
                this.$refs.form?.clearValidate();
            });
        },
        closeDialog() {
            this.resetForm();
            this.$emit("closeDialog");
        },
        submit() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                this.$emit("submit", {
                    processingStatus: this.form.processingStatus,
                    note: (this.form.note || "").trim(),
                });
            });
        },
    },
};
</script>

<style scoped>
.approve-refund-dialog {
    padding: 4px 4px 0;
}

.w-100 {
    width: 100%;
}

.approve-refund-dialog :deep(.el-form-item) {
    margin-bottom: 14px;
}

.approve-refund-dialog :deep(.el-form-item__label) {
    padding-bottom: 6px;
    line-height: 1.35;
    color: #3f4254;
    font-weight: 500;
}

.approve-refund-dialog :deep(.el-input__inner),
.approve-refund-dialog :deep(.el-textarea__inner) {
    border-radius: 6px;
}

.approve-refund-dialog :deep(.el-input__inner) {
    height: 40px;
    line-height: 40px;
}

.approve-refund-dialog :deep(.el-form-item:last-child) {
    margin-bottom: 0;
}

.approve-refund-dialog__footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 18px;
    padding-top: 14px;
    border-top: 1px solid #ebedf3;
}

.btn-secondary-muted {
    background: #cacaca;
    border: none;
    color: #333;
}

.approve-refund-dialog__footer .btn {
    min-width: 86px;
    height: 38px;
    border-radius: 4px;
}

.approve-refund-dialog__btn-submit {
    margin: 0;
}
</style>
